export default function MotherOfMercyPage () {
    return (
        <div class="flex justify-center min-h-screen">
            <div class="text-center max-w-2xl p-6">
                <h1 className="text-3xl font-bold text-center my-6">Mother of Mercy Group</h1>
                <p class="text-base text-black mb-6">
                    The Mother of Mercy is an outreach to the homeless people in our city.  A catholic group of volunteers who accompany, 
                    through service on the streets, our homeless brothers and sisters.  The group have been resident at Our Lady Queen of 
                    Martyrs Church since 2009.  We are made up of parishioners from various parishes throughout Liverpool including St 
                    Teresa’s, responding to the call to become ‘A Family of Parishes’.
                    Working together with our parish community to help alleviate the suffering of the poor, is at the heart of our ministry.
                </p>
                <p class="text-base text-black mb-6 italic">
                    <span>“Truly I tell you, whatever you did to the least of these brothers and sisters of mine, you did to me”.</span><br/>
                    <span class="not-italic block mt-2">(M 23:40)</span>
                </p>
                <p class="text-base text-black mb-6">
                    This beautiful act of God’s love through service immersed in the joy of the Gospel, is soaked in prayer, beginning 
                    with our celebration of the Holy Mass and devotion in the Church to the Blessed Sacrament and the Mysteries of the 
                    Holy Rosary.
                </p>
                <p class="text-xl font-semibold text-blue-800 my-6">
                    We meet Tuesdays at 9.00am in church. All welcome!
                </p>
            </div>
        </div>
    )
}